import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Messages Redux States
import { SET_INSIGHTS } from "./actionTypes";
import { insightsError, setInsightsSuccess } from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* setInsights({ payload: newInsightValues }) {
  let valueToSend = { ...newInsightValues };
  delete valueToSend.name;
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/conversation/insights`,
      valueToSend
    );

    if (response.status === 200) {
      yield put(setInsightsSuccess(newInsightValues));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Set insight error";
    yield put(insightsError({ action: "set_insights", message: message }));
  }
}

export function* watchGetInsights() {
  yield takeEvery(SET_INSIGHTS, setInsights);
}
function* authSaga() {
  yield all([fork(watchGetInsights)]);
}

export default authSaga;
